var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "#E74C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6496 25.5312C38.9447 24.1383 39.5357 22.9319 39.2024 22.2173C38.869 21.5023 37.564 21.1796 35.6631 21.2768C36.611 22.5131 37.3001 23.9582 37.6496 25.5312ZM33.0472 18.8272C31.3168 17.6729 29.2379 17 27.0017 17C21.3856 17 16.7609 21.2444 16.1603 26.7005C12.8876 29.5073 11.2573 32.4575 12.3262 34.7498C13.395 37.0419 16.7023 37.6895 20.9553 36.987C22.6859 38.1418 24.7652 38.8149 27.0017 38.8149C32.6191 38.8149 37.2446 34.5686 37.8436 29.1108C41.1137 26.3051 42.7423 23.3562 41.6738 21.0648C40.6052 18.7733 37.299 18.1254 33.0472 18.8272ZM21.6178 34.0672C19.9035 32.5676 18.8207 30.364 18.8207 27.9075C18.8207 23.3894 22.4833 19.7269 27.0013 19.7269C31.4641 19.7269 35.0923 23.3005 35.1803 27.7423C33.447 29.0788 31.2449 30.441 28.7286 31.6144C26.2133 32.7873 23.7552 33.5984 21.6178 34.0672ZM25.2854 35.9078C26.7778 35.4226 28.3232 34.8122 29.8811 34.0858C31.4397 33.359 32.9015 32.567 34.233 31.7351C32.8597 34.3244 30.1365 36.088 27.0013 36.088C26.4127 36.088 25.8387 36.0259 25.2854 35.9078ZM18.3401 34.5377C16.4375 34.6355 15.1312 34.3128 14.7976 33.5974C14.4641 32.8823 15.0561 31.6747 16.3532 30.2805C16.7024 31.8546 17.3917 33.3007 18.3401 34.5377Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.c7511c239b6b2c1e565e9c2e9fffb95e.svg";
export { ForwardRef as ReactComponent };